export default {

    listAdhoc: "service/listAdhoc",
    list: "service/list",

    add: "service/add",
    
    editName: 'service/editName',
    editStockCode: 'service/editStockCode',
    editProvider: 'service/editProvider',
    editCostCenter: 'service/editCostCenter',
    editCost: 'service/editCost'
    
};